module.exports = __webpack_public_path__ + "static/media/find_your_calling_hero.41be4c40.png";